module.exports = __webpack_public_path__ + "img/elenco.a7291c98.svg";